/* =============================================================
   FUTUR FLARE — theme-custom.js
   Interactions PDP (sélecteurs, galerie, qty, accordéons)
   + Animations homepage (GSAP + ScrollTrigger + count-up)
   Chargé en defer. Respecte prefers-reduced-motion.
   ============================================================= */
(function () {
  'use strict';

  /* --- Détections ---------------------------------------------- */
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isCoarsePointer     = window.matchMedia('(pointer: coarse)').matches;
  const isLowEnd =
    (navigator.deviceMemory && navigator.deviceMemory < 4) ||
    (navigator.hardwareConcurrency && navigator.hardwareConcurrency < 4);

  window.FF = window.FF || {};
  window.FF.env = { prefersReducedMotion, isCoarsePointer, isLowEnd };

  /* --- 1. Pressable groups (size/color selectors) -------------- */
  function initPressableGroups() {
    document.querySelectorAll('[data-ff-group]').forEach(group => {
      const buttons = group.querySelectorAll('[aria-pressed]');
      buttons.forEach(btn => {
        btn.addEventListener('click', () => {
          if (btn.hasAttribute('disabled')) return;
          buttons.forEach(b => b.setAttribute('aria-pressed', 'false'));
          btn.setAttribute('aria-pressed', 'true');

          // Sync le radio input associé + trigger change
          const inputId = btn.getAttribute('for');
          const input = inputId ? document.getElementById(inputId) : null;
          if (input) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }

          group.dispatchEvent(new CustomEvent('ff:change', {
            detail: { value: btn.dataset.value }, bubbles: true
          }));
        });
      });
    });
  }

  /* --- 1b. Colorize swatches (map FR/EN + CSS names) ----------- */
  const FF_COLOR_MAP = {
    'noir': '#0A0A0B',      'black': '#0A0A0B',
    'blanc': '#F4F1EA',     'white': '#FFFFFF',
    'creme': '#EFE8D9',     'cream': '#EFE8D9', 'crème': '#EFE8D9',
    'beige': '#D6C9B0',
    'gris': '#808080',      'grey': '#808080',  'gray': '#808080',
    'argent': '#B4B4B8',    'silver': '#B4B4B8',
    'rouge': '#C8102E',     'red': '#C8102E',
    'bleu': '#1F3D91',      'blue': '#1F3D91',
    'marine': '#0B1F3A',    'navy': '#0B1F3A',
    'vert': '#2E7D32',      'green': '#2E7D32',
    'kaki': '#6B6C3E',      'khaki': '#6B6C3E',
    'olive': '#3E4330',
    'marron': '#5D3A1F',    'brown': '#5D3A1F',
    'jaune': '#F1C232',     'yellow': '#F1C232',
    'orange': '#F57C00',
    'rose': '#E88BA5',      'pink': '#E88BA5',
    'violet': '#7E57C2',    'purple': '#7E57C2',
    'multi': 'linear-gradient(90deg,#C8102E,#F1C232,#2E7D32,#1F3D91,#7E57C2)',
    'multicolore': 'linear-gradient(90deg,#C8102E,#F1C232,#2E7D32,#1F3D91,#7E57C2)'
  };
  function normalizeColorName(s) {
    return String(s || '').toLowerCase().trim()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // strip accents
      .replace(/[\s_-]+/g, ' ');
  }
  function initSwatchColors() {
    document.querySelectorAll('.ff-swatch__color[data-color-name]').forEach(el => {
      const raw = el.dataset.colorName;
      const norm = normalizeColorName(raw);
      // 1) map exact
      if (FF_COLOR_MAP[norm]) {
        el.style.background = FF_COLOR_MAP[norm];
        return;
      }
      // 2) token inclus dans nom compose (ex: "Noir profond" → "noir")
      for (const key of Object.keys(FF_COLOR_MAP)) {
        if (norm.split(' ').includes(key)) {
          el.style.background = FF_COLOR_MAP[key];
          return;
        }
      }
      // 3) fallback : nom CSS natif (blue, red, navy, etc.)
      const test = document.createElement('div');
      test.style.color = norm.replace(/\s+/g, '');
      if (test.style.color) {
        el.style.background = norm.replace(/\s+/g, '');
      }
      // 4) sinon le fallback gris foncé du CSS reste
    });
  }

  /* --- 1c. Variant switcher : option change → variant + image - */
  function initVariantSwitcher() {
    const pdp = document.querySelector('[data-ff-pdp]');
    if (!pdp) return;
    const dataScript = document.querySelector('[data-ff-product-json]');
    if (!dataScript) return;
    let productData;
    try { productData = JSON.parse(dataScript.textContent); } catch (e) { return; }

    const hiddenSelect = pdp.querySelector('[data-ff-variant-select]');
    const mainImg = pdp.querySelector('[data-ff-gallery-main] img');
    const mobileTrack = pdp.querySelector('[data-ff-gallery-track]');
    const priceEl = pdp.querySelector('[data-ff-price]');
    const priceCutEl = pdp.querySelector('[data-ff-price-cut]');
    const atcBtn = pdp.querySelector('[data-ff-atc]');
    const atcLabel = pdp.querySelector('[data-ff-atc-label]');

    function getSelectedValues() {
      const groups = pdp.querySelectorAll('[data-ff-option-group]');
      const values = [];
      groups.forEach(g => {
        const idx = parseInt(g.dataset.optionIndex, 10);
        const checked = g.querySelector('input[type="radio"]:checked');
        values[idx] = checked ? checked.value : null;
      });
      return values;
    }

    function findMatchingVariant(selected) {
      return productData.variants.find(v =>
        v.options.every((opt, i) => opt === selected[i])
      );
    }

    function formatPrice(cents) {
      const euros = (cents / 100).toFixed(2).replace('.', ',');
      return euros + ' €';
    }

    function updateForSelection() {
      const selected = getSelectedValues();
      const variant = findMatchingVariant(selected);
      if (!variant) return;

      // Update hidden select for the form
      if (hiddenSelect) hiddenSelect.value = variant.id;

      // Update URL (without reloading)
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      } catch (e) { /* ignore */ }

      // Update price
      if (priceEl) priceEl.textContent = formatPrice(variant.price);
      if (priceCutEl) {
        if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
          priceCutEl.textContent = formatPrice(variant.compareAtPrice);
          priceCutEl.style.display = '';
        } else {
          priceCutEl.style.display = 'none';
        }
      }

      // Update ATC button
      if (atcBtn && atcLabel) {
        if (variant.available) {
          atcBtn.removeAttribute('disabled');
          atcBtn.removeAttribute('aria-disabled');
          atcLabel.textContent = 'Ajouter au panier';
        } else {
          atcBtn.setAttribute('disabled', '');
          atcBtn.setAttribute('aria-disabled', 'true');
          atcLabel.textContent = 'Épuisé';
        }
      }

      // ===== Update main image + thumbs + mobile carousel =====
      // Multi-strategy ROBUSTE — Strategy 0 reproduit la logique des swatches
      // (qui s'affichent visuellement corrects). On prend la 1ère variante de la
      // couleur qui a une image, peu importe la taille.
      const thumbs = pdp.querySelectorAll('[data-ff-gallery-thumb]');
      const dots   = pdp.querySelectorAll('[data-ff-gallery-dot]');
      let targetImage = null;
      let matchIdx = -1;

      // Identifie l'index de l'option "couleur" parmi les options produit
      const colorOptionIdx = (productData.options || []).findIndex(n =>
        /couleur|color|colour/i.test(n)
      );
      const selectedColor = colorOptionIdx >= 0 ? selected[colorOptionIdx] : null;
      const selectedColorLc = (selectedColor || '').toString().toLowerCase().trim();

      // Normalise : retire accents, espaces, tirets, lowercase
      const normalize = s => (s || '').toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[\s_-]+/g, '');
      const colorNorm = normalize(selectedColorLc);

      // ─── Strategy 0 (PRIORITY ABSOLUE) : 1ère variante de cette couleur avec image
      // Reproduit EXACTEMENT la logique des swatches en Liquid. Les swatches affichent
      // visuellement la bonne couleur → cette image est fiable pour main img aussi.
      if (colorOptionIdx >= 0 && selectedColor) {
        const firstColorVariantWithImage = productData.variants.find(v =>
          v.options[colorOptionIdx] === selectedColor && v.image
        );
        if (firstColorVariantWithImage) {
          targetImage = firstColorVariantWithImage.image;
          const targetBase = (targetImage || '').split('?')[0];
          thumbs.forEach((t, i) => {
            const thumbBase = (t.dataset.full || '').split('?')[0];
            if (thumbBase === targetBase
                || String(t.dataset.mediaId) === String(firstColorVariantWithImage.mediaId)) {
              matchIdx = i;
            }
          });
        }
      }

      // Synonymes FR/EN pour élargir le match (utilisés par strategies 1-2)
      const colorSynonyms = {
        'noir':     ['noir', 'black', 'blk'],
        'noiretblanc': ['noiretblanc', 'blackandwhite', 'bw'],
        'blanc':    ['blanc', 'white', 'wht'],
        'rouge':    ['rouge', 'red'],
        'bleu':     ['bleu', 'blue'],
        'bleunuit': ['bleunuit', 'navyblue', 'navy', 'darkblue'],
        'vert':     ['vert', 'green'],
        'rose':     ['rose', 'pink'],
        'gris':     ['gris', 'grey', 'gray'],
        'jaune':    ['jaune', 'yellow'],
        'orange':   ['orange'],
        'violet':   ['violet', 'purple'],
        'marron':   ['marron', 'brown', 'coffee', 'cafe'],
        'beige':    ['beige', 'cream', 'ivory'],
      };
      let searchTokens = colorNorm ? [colorNorm] : [];
      for (const [key, syns] of Object.entries(colorSynonyms)) {
        if (syns.includes(colorNorm) || (colorNorm && colorNorm.includes(key))) {
          searchTokens = [...new Set([...searchTokens, key, ...syns])];
        }
      }

      // ─── Strategy 1 : match sur productData.medias (alt + filename)
      // Utilisé seulement si Strategy 0 n'a rien trouvé (aucune variante de cette
      // couleur n'a d'image assignée dans l'admin).
      if (!targetImage && productData.medias && productData.medias.length > 0 && searchTokens.length > 0) {
        for (const media of productData.medias) {
          if (!media.src) continue;
          const altNorm = normalize(media.alt);
          const srcNorm = normalize(media.src);
          const matched = searchTokens.some(tok => tok && (altNorm.includes(tok) || srcNorm.includes(tok)));
          if (matched) {
            targetImage = media.src;
            thumbs.forEach((t, i) => {
              if (String(t.dataset.mediaId) === String(media.id)) matchIdx = i;
            });
            break;
          }
        }
      }

      // ─── Strategy 2 : match par alt/src des thumbs DOM (fallback si medias[] absent)
      // IMPORTANT : ne PAS écraser targetImage si déjà défini par Strategy 0.
      // Si targetImage est set mais pas de thumb match → on garde cette image et on
      // met juste matchIdx = -1 (pas de highlight).
      if (!targetImage && searchTokens.length > 0) {
        thumbs.forEach((t, i) => {
          if (matchIdx !== -1) return;
          const img = t.querySelector('img');
          const altText = normalize(img?.alt || '');
          const srcText = normalize(t.dataset.full || '');
          const matched = searchTokens.some(tok => tok && (altText.includes(tok) || srcText.includes(tok)));
          if (matched) {
            matchIdx = i;
            targetImage = t.dataset.full;
          }
        });
      }

      // ─── Strategy 3 : mapping position couleur ↔ position thumb
      // IMPORTANT : seulement si targetImage non défini par Strategy 0/1/2.
      if (!targetImage && colorOptionIdx >= 0 && thumbs.length > 0) {
        const uniqueColors = [];
        productData.variants.forEach(v => {
          const c = v.options[colorOptionIdx];
          if (c && !uniqueColors.includes(c)) uniqueColors.push(c);
        });
        const colorIdx = uniqueColors.indexOf(selectedColor);
        if (colorIdx >= 0 && colorIdx < thumbs.length) {
          matchIdx = colorIdx;
          targetImage = thumbs[colorIdx].dataset.full;
        }
      }

      // ─── Strategy 4 (dernier recours) : variant.image assigné en admin
      if (!targetImage && variant.image) {
        targetImage = variant.image;
        thumbs.forEach((t, i) => {
          if (t.dataset.full === variant.image || String(t.dataset.mediaId) === String(variant.mediaId)) {
            matchIdx = i;
          }
        });
      }

      // Apply the image swap avec fade léger pour transition smooth
      // CRITICAL FIX : vider srcset/sizes avant de set src, sinon le navigateur
      // utilise srcset (généré pour product.featured_media, pas pour la variante)
      // et ignore notre src → l'image ne change pas visuellement.
      if (targetImage && mainImg) {
        const oldSrc = mainImg.currentSrc || mainImg.src;
        if (!oldSrc.includes(targetImage.split('?')[0].split('/').pop())) {
          mainImg.style.transition = 'opacity 180ms ease';
          mainImg.style.opacity = '0.4';
          // Précharge pour éviter flash blanc
          const preload = new Image();
          const applySwap = () => {
            // Retire srcset + sizes pour que le navigateur utilise .src
            mainImg.removeAttribute('srcset');
            mainImg.removeAttribute('sizes');
            mainImg.src = targetImage;
            requestAnimationFrame(() => { mainImg.style.opacity = '1'; });
          };
          preload.onload = applySwap;
          preload.onerror = () => {
            mainImg.removeAttribute('srcset');
            mainImg.removeAttribute('sizes');
            mainImg.src = targetImage;
            mainImg.style.opacity = '1';
          };
          preload.src = targetImage;
        }
      }
      if (matchIdx >= 0) {
        // Desktop : highlight active thumb
        thumbs.forEach((t, i) => t.setAttribute('aria-current', i === matchIdx ? 'true' : 'false'));
        // Mobile : scroll to variant image + update dots
        if (mobileTrack) {
          mobileTrack.scrollTo({ left: matchIdx * mobileTrack.clientWidth, behavior: 'smooth' });
          dots.forEach((d, i) => d.setAttribute('aria-current', i === matchIdx ? 'true' : 'false'));
        }
      }

      if (!targetImage && !variant.image) {
        console.info('[FF] Variant "' + variant.title + '" sans image trouvée (toutes stratégies). Ordre couleurs & photos doivent correspondre, OU assigner explicitement dans l\'admin.');
      }

      // Update "selected value" labels
      pdp.querySelectorAll('[data-ff-option-selected]').forEach(el => {
        const idx = parseInt(el.dataset.ffOptionSelected, 10);
        if (selected[idx]) el.textContent = selected[idx];
      });
    }

    // Sync initial : assure que l'image affichée au load correspond au variant sélectionné
    // (notamment si le user arrive avec ?variant=XX dans l'URL, ou si le variant par défaut
    // n'a pas d'image assignée et qu'on doit faire le match par ordre des couleurs).
    requestAnimationFrame(() => updateForSelection());

    // Listen to any option change
    pdp.querySelectorAll('input[type="radio"][name^="options"]').forEach(input => {
      input.addEventListener('change', updateForSelection);
    });
  }

  /* --- 1d. Cross-sell Shopify Recommendations ------------------ */
  function initRecommendations() {
    const container = document.querySelector('[data-ff-recommendations]');
    if (!container) return;
    const url = container.dataset.url;
    if (!url) return;
    // Fetch la section via Section Rendering API
    // (retourne la section déjà Liquid-rendered avec les recommandations)
    fetch(url)
      .then(r => r.ok ? r.text() : Promise.reject(r.status))
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = doc.querySelector('[data-ff-recommendations-grid]');
        const oldGrid = container.querySelector('[data-ff-recommendations-grid]');
        if (newGrid && oldGrid) {
          const hasCards = newGrid.querySelector('.ff-card:not(.ff-card--skeleton)');
          if (hasCards) {
            oldGrid.replaceWith(newGrid);
          } else {
            // Pas de recommandations disponibles → cache la section entière
            container.style.display = 'none';
          }
        }
      })
      .catch(() => {
        container.style.display = 'none';
      });
  }

  /* --- 2. Galerie produit desktop ------------------------------ */
  function initGallery() {
    const gallery = document.querySelector('[data-ff-gallery]');
    if (!gallery) return;
    const mainImg = gallery.querySelector('[data-ff-gallery-main] img');
    const thumbs  = gallery.querySelectorAll('[data-ff-gallery-thumb]');
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.full || thumb.querySelector('img').src;
        if (mainImg) mainImg.src = src;
        thumbs.forEach(t => t.setAttribute('aria-current', 'false'));
        thumb.setAttribute('aria-current', 'true');
      });
    });
  }

  /* --- 3. Carrousel mobile via scroll-snap --------------------- */
  function initMobileGallery() {
    const track = document.querySelector('[data-ff-gallery-track]');
    if (!track) return;
    const dots = document.querySelectorAll('[data-ff-gallery-dot]');
    track.addEventListener('scroll', () => {
      const index = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach((d, i) => d.setAttribute('aria-current', i === index ? 'true' : 'false'));
    }, { passive: true });
  }

  /* --- 4. Accordéons ------------------------------------------- */
  function initAccordions() {
    document.querySelectorAll('[data-ff-accordion]').forEach(acc => {
      const items = acc.querySelectorAll('details');
      items.forEach(item => {
        item.addEventListener('toggle', () => {
          if (item.open && acc.hasAttribute('data-ff-accordion-exclusive')) {
            items.forEach(o => { if (o !== item) o.open = false; });
          }
        });
      });
    });
  }

  /* --- 5. Quantité --------------------------------------------- */
  function initQtyInputs() {
    document.querySelectorAll('[data-ff-qty]').forEach(box => {
      const input = box.querySelector('input');
      const minus = box.querySelector('[data-ff-qty-minus]');
      const plus  = box.querySelector('[data-ff-qty-plus]');
      const clamp = v => Math.min(99, Math.max(1, parseInt(v, 10) || 1));
      if (minus) minus.addEventListener('click', () => { input.value = Math.max(1, clamp(input.value) - 1); input.dispatchEvent(new Event('change', { bubbles: true })); });
      if (plus)  plus.addEventListener('click',  () => { input.value = clamp(input.value) + 1; input.dispatchEvent(new Event('change', { bubbles: true })); });
      input.addEventListener('input', () => { input.value = clamp(input.value); });
    });
  }

  /* --- 6. Split text ------------------------------------------- */
  // On transforme chaque [data-ff-split] en spans char/word pour animer.
  function splitText(el) {
    const text = el.textContent;
    el.textContent = '';
    el.classList.add('ff-reveal-chars');
    const words = text.split(/(\s+)/);
    words.forEach(word => {
      if (/^\s+$/.test(word)) {
        el.appendChild(document.createTextNode(word));
        return;
      }
      const wSpan = document.createElement('span');
      wSpan.style.display = 'inline-block';
      wSpan.style.whiteSpace = 'nowrap';
      [...word].forEach(c => {
        const s = document.createElement('span');
        s.textContent = c;
        wSpan.appendChild(s);
      });
      el.appendChild(wSpan);
    });
  }

  /* --- 7. Count-up --------------------------------------------- */
  function animateCount(el) {
    const to = parseFloat(el.dataset.ffCountTo);
    const decimals = parseInt(el.dataset.ffCountDecimals || '0', 10);
    const dur = 1800;
    const t0 = performance.now();
    const ease = t => 1 - Math.pow(1 - t, 3);
    function step(now) {
      const p = Math.min(1, (now - t0) / dur);
      const v = to * ease(p);
      el.textContent = decimals ? v.toFixed(decimals) : Math.round(v).toLocaleString('fr-FR');
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = decimals ? to.toFixed(decimals) : Math.round(to).toLocaleString('fr-FR');
    }
    requestAnimationFrame(step);
  }

  /* --- 8. Particules 2D canvas fallback hero ------------------- */
  function initHeroCanvas() {
    const canvas = document.querySelector('.ff-hero__canvas');
    if (!canvas) return;
    const three = document.querySelector('[data-ff-hero-three]');
    // Si Three.js est actif (attribut "ready" posé), on skippe le canvas 2D
    if (three && three.getAttribute('data-ff-three-status') === 'ready') {
      canvas.style.display = 'none';
      return;
    }
    if (prefersReducedMotion) return;

    const ctx = canvas.getContext('2d');
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    function resize() {
      canvas.width  = canvas.offsetWidth  * dpr;
      canvas.height = canvas.offsetHeight * dpr;
    }
    resize();
    window.addEventListener('resize', resize);

    const count = isLowEnd ? 20 : (isCoarsePointer ? 30 : 55);
    const p = [];
    for (let i = 0; i < count; i++) {
      p.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        r: (Math.random() * 1.6 + 0.3) * dpr,
        vx: (Math.random() - 0.5) * 0.12 * dpr,
        vy: (Math.random() - 0.5) * 0.12 * dpr,
        o: Math.random() * 0.5 + 0.15
      });
    }

    let running = true;
    document.addEventListener('visibilitychange', () => { running = !document.hidden; });

    function tick() {
      if (running) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        for (const pt of p) {
          pt.x += pt.vx; pt.y += pt.vy;
          if (pt.x < 0 || pt.x > canvas.width) pt.vx *= -1;
          if (pt.y < 0 || pt.y > canvas.height) pt.vy *= -1;
          ctx.beginPath();
          ctx.arc(pt.x, pt.y, pt.r, 0, Math.PI * 2);
          ctx.fillStyle = `rgba(201, 169, 97, ${pt.o})`;
          ctx.fill();
        }
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  /* --- 9. GSAP + ScrollTrigger animations ---------------------- */
  function initAnimations() {
    const hasGsap = !!window.gsap;
    const hasSt   = !!window.ScrollTrigger;
    if (!hasGsap || !hasSt) {
      // Fallback : reveal instantané sans animation
      document.querySelectorAll('.ff-reveal').forEach(el => el.classList.add('ff-reveal--in'));
      return;
    }
    const gsap = window.gsap;
    gsap.registerPlugin(window.ScrollTrigger);

    // Split text sur tous les [data-ff-split]
    document.querySelectorAll('[data-ff-split]').forEach(splitText);

    // Split hero : reveal char par char
    document.querySelectorAll('.ff-hero [data-ff-split] span > span').forEach(() => {});

    if (prefersReducedMotion) {
      document.querySelectorAll('.ff-reveal').forEach(el => el.classList.add('ff-reveal--in'));
      document.querySelectorAll('.ff-reveal-chars span span').forEach(el => { el.style.opacity = 1; el.style.transform = 'none'; });
      return;
    }

    // Hero : chars stagger (from-only : state final = visible par défaut)
    const heroChars = document.querySelectorAll('.ff-hero [data-ff-split] span > span');
    if (heroChars.length) {
      gsap.from(heroChars, {
        opacity: 0, y: 18,
        stagger: 0.018, duration: 0.65, ease: 'power3.out', delay: 0.4,
        immediateRender: false
      });
    }

    // Hero logo "FF" : scan-in vertical (from-only, pas de clipPath qui risque de bloquer)
    const heroLogo = document.querySelector('[data-ff-hero-logo]');
    if (heroLogo) {
      gsap.from(heroLogo, {
        opacity: 0, y: 20,
        duration: 0.8, ease: 'power3.out', delay: 0.15,
        immediateRender: false
      });
    }

    // Hero ring : fade + scale subtil (from-only)
    const heroRing = document.querySelector('.ff-hero__ring');
    if (heroRing) {
      gsap.from(heroRing, {
        opacity: 0, scale: 0.88,
        duration: 1.2, ease: 'expo.out', delay: 0.1,
        immediateRender: false
      });
    }

    // Reveal générique (from-only + ScrollTrigger)
    gsap.utils.toArray('.ff-reveal').forEach((el) => {
      gsap.from(el, {
        opacity: 0, y: 28,
        duration: 0.75, ease: 'power2.out',
        immediateRender: false,
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
          once: true
        },
        onStart() { el.classList.add('ff-reveal--in'); }
      });
    });

    // Banner qualité : chars stagger plus lent (from-only)
    document.querySelectorAll('.ff-quality-banner [data-ff-split]').forEach(el => {
      const chars = el.querySelectorAll('span > span');
      gsap.from(chars, {
        opacity: 0, y: 20,
        stagger: 0.012, duration: 0.7, ease: 'power3.out',
        immediateRender: false,
        scrollTrigger: { trigger: el, start: 'top 80%', once: true }
      });
    });

    // Count-up stats
    document.querySelectorAll('[data-ff-count]').forEach(el => {
      window.ScrollTrigger.create({
        trigger: el,
        start: 'top 85%',
        once: true,
        onEnter: () => animateCount(el)
      });
    });

    // Parallax léger sur backgrounds collection
    document.querySelectorAll('[data-ff-parallax]').forEach(bg => {
      gsap.to(bg, {
        yPercent: -12,
        ease: 'none',
        scrollTrigger: {
          trigger: bg.closest('.ff-collection') || bg,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      });
    });
  }

  /* --- INIT ---------------------------------------------------- */
  function init() {
    initPressableGroups();
    initSwatchColors();
    initVariantSwitcher();
    initRecommendations();
    initGallery();
    initMobileGallery();
    initAccordions();
    initQtyInputs();
    initHeroCanvas();
    initAnimations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
